<template>
	<div class="qualification-body">
		<div class="name-box">
			<div class="input-box">
				<span style="font-size:14px">店铺名称：{{shopName}}</span>
			</div>
		</div>
		<div class="qualification-container">
			<div class="img-box">
				<p>自定义店铺首页广告图</p>
				<div class="img-tips">图片尺寸最优比例750*266，1M以内，格式：JPG/JPEG/PNG</div>
				<div class="img-container">
					<ImgUpload
						class="show-img"
						v-for="(item, index) in showSrc"
						:key="index"
						:location="item.location"
						:imgSrc.sync="item.imgurl"
						:imgId.sync="item.id"
						:uploadError.sync="item.uploadError"
						:statusIcon.sync="statusIcon"
						:editDisable="editDisable"
						@deletImg="deletImg"
						@getImg="getImg"
						ref="showUpload"
					/>
					<ImgUpload2
						class="show-img"
						v-if="showSrc.length < 6"
						@uploadNewImg="uploadNewImg"
						ref="showUpload2"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ImgUpload from '@/components/storeSetting/shopDecorate/ImgUpload.vue'
import ImgUpload2 from '@/components/storeSetting/shopDecorate/ImgUpload2.vue'
export default {
	name: 'shopDecorate',
	components: {
		ImgUpload, ImgUpload2
	},
	data () {
		return {
			showSrc: [
				// { src: '', location: '1', id: '0', uploadError: false, imgtype: 0 }
			],
			editDisable: true,
			statusIcon: 'submit'
		}
	},
	created () {
		this.shopName = window.sessionStorage.getItem('shopName')
		// this.getAuthority('01_0001_0000_00')
		this.getImg()
	},
	methods: {
		uploadNewImg () {
			let needUrl = `${this.$fxBaseApi.urlQIVShop}/upload/adImg`
			var formData = new FormData()
			formData.append('shopid', sessionStorage.getItem('storeid'))
			formData.append('extension', this.$refs.showUpload2.fileFiles.name.split('.')[1])
			formData.append('file', this.$refs.showUpload2.fileFiles)
			this.$store.dispatch('requestFilePost', {
				url: needUrl,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success('上传图片成功')
					this.getImg()
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		getImg () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/find/adImg/` + sessionStorage.getItem('storeid')
			}).then(res => {
				if (res.result) {
					this.showSrc = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		deletImg (id, path) {
			let params = {
				dataid: id,
				deletePath: path
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/removeImg/`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功')
					this.getImg()
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		qualificationChange (value) {
			this.componentShow = value === '0'
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					if (a.indexOf('01_0001_0001_00') > -1) {
						this.editDisable = true
					} else {
						if (window.sessionStorage.getItem('isAdd') === 'true') {
							this.editDisable = true
						} else {
							this.editDisable = false
						}
					}
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.qualification-body {
	display: flex
	flex: 1
	height: 100%
	flex-direction column
	.name-box{
		height :60px;
		line-height :60px;
		text-align :left;
		border-bottom 1px solid #dce2fd
		.input-box{
			margin-left :10px;
			overflow-x :hidden
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
	.qualification-container {
		display: flex;
		flex: 1;
		overflow-y: auto;
		flex-direction: column;
		.img-box {
			flex: 1
			text-align: left
			margin-top: 20px
			padding-left: 10px
			box-sizing: border-box
			p {
				height 20px
				font-size 16px
				line-height 20px
				border-left 4px solid var(--fx-primary-color)
				padding-left 8px
			}
			.img-container {
				width: 100%
			}
			.img-tips {
				padding: 20px 0 20px 12px
				color: #a7a7a7
			}
		}
	}
}
</style>
